"use client";

import { useQuery } from "@apollo/client";
import { GET_COUNTRIES } from "@/graphql/queries/countries-query";
import { GET_COUNTRY_BY_ID } from "@/graphql/queries/country-by-id-query";
import { useMemo, useState, useCallback } from "react";

const useLocations = () => {
  const [selectedCountryId, setSelectedCountryId] = useState<string>();

  const {
    data: countriesData,
    loading: countriesLoading,
    error: countriesError,
  } = useQuery(GET_COUNTRIES, {
    fetchPolicy: "network-only",
  });

  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(GET_COUNTRY_BY_ID, {
    variables: { ID: selectedCountryId ? parseInt(selectedCountryId) : 0 },
    skip: !selectedCountryId,
    fetchPolicy: "cache-and-network",
  });

  const countries = useMemo(
    () => countriesData?.countries || [],
    [countriesData?.countries]
  );
  const cities = useMemo(
    () => countryData?.country?.cities || [],
    [countryData?.country?.cities]
  );

  const handleCountrySelect = useCallback((countryId: string) => {
    setSelectedCountryId(countryId);
  }, []);

  const loading = useMemo(() => {
    if (!countriesData && countriesLoading) return true;
    if (selectedCountryId && countryLoading) return true;
    return false;
  }, [countriesData, countriesLoading, selectedCountryId, countryLoading]);

  return {
    countries,
    cities,
    selectedCountryId,
    setSelectedCountry: handleCountrySelect,
    loading,
    error: countriesError || countryError,
  };
};

export default useLocations;
